import type { ReactElement } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@shigo-ui/ui';

interface DashboardTruncatedNameProps {
  children: ReactElement;
  name: string;
}

export const dashboardTruncatedNameClassName =
  'block min-w-0 w-full max-w-60 truncate whitespace-nowrap';

export function DashboardTruncatedName({ children, name }: DashboardTruncatedNameProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent className="max-w-sm break-words">{name}</TooltipContent>
    </Tooltip>
  );
}
